import Styled from "@emotion/styled";
import React from "react";
import BuySellFilter from "@components/buy-sell-filter";
import HeaderTitleProfile from "@components/header-title-profile";
import { useEffect, useState } from "react";
import { AgencyPicPlaceholder } from "shared/models/const/placeholder-images.const";
import { IAgentResponseData } from "shared/models/interfaces/response/agent.interface";
import { CPagesPath } from "shared/models/const/pages-path";
import { useRouter } from "next/router";
import { useSessionStorage } from "usehooks-ts";
import { useTranslations } from "next-intl";
import { IAgencyResponse } from "shared/models/interfaces/response/agency.interface";
import { useWidth } from "custom-hooks/use-width.hook";
import ContactSection from "./components/contact-section";
import SliderSection from "./components/sliders-section";

export interface IAgencyProfileContain {
  id: number;
  data: IAgencyResponse;
}

function AgencyProfileContain(props: IAgencyProfileContain) {
  const width = useWidth();
  const router = useRouter();
  const translation = useTranslations("agencyProfile");
  const agencyTitle = translation("title") || "";
  const [title, ...rest] = agencyTitle.split(" ");
  const [code, setCode] = useSessionStorage("code", { id: null, type: null });
  const translationProfile = useTranslations("agencyProfile.profile");
  const [profileInfo, setProfileInfo] = useState<IAgentResponseData | any>(
    adapterAgent(null)
  );

  useEffect(() => {
    setProfileInfo(adapterAgent(props.data.data));

    let agencyCode: any = {
      type: "areferer",
      id: props.id,
    };
    setCode(agencyCode);

    const url = `/agencia/${props.data.data.name
      .replaceAll(" ", "-")
      .replace("re max", "RE/MAX")
      .replace("/", "-")
      .toLowerCase()}/${props.data.data.id}?areferer=${props.id}`;

    router.replace(url, undefined, { shallow: true });
  }, []);

  let config = {
    profileInfo,
  };

  return (
    <Content>
      <HeaderTitleProfile label={rest.join(" ")} title={title} />
      <Card>
        <CardContainer className="container">
          <Thumbnail src={profileInfo.picture} />
          <ContentDetail>
            {!["xs", "sm"].includes(width) && (
              <LabelNameAgency>{profileInfo.name}</LabelNameAgency>
            )}
            <ContentInfo>
              <ContentInfoItem>
                <Info className="--title">Bróker(s)</Info>
                <Info className="--description">{profileInfo.brokers}</Info>
              </ContentInfoItem>
              <ContentInfoItem>
                <Info className="--title">{translationProfile("email")}</Info>
                <Info className="--description">{profileInfo.email}</Info>
              </ContentInfoItem>
              <ContentInfoItem>
                <Info className="--title">{translationProfile("address")}</Info>
                <Info className="--description">{profileInfo.address}</Info>
              </ContentInfoItem>
            </ContentInfo>

            {/* <Rating value={profileInfo.rating} readOnly /> */}
          </ContentDetail>

          <ContactSection profileInfo={profileInfo} isAgency={true} />
        </CardContainer>
        <FilterContainer>
          <BuySellFilter redirect={CPagesPath.es.properties} />
        </FilterContainer>
      </Card>
      <SliderSection {...config} />
    </Content>
  );
}

const Content = Styled.div`
  margin-top: 100px;
  @media screen and (max-width: 767px) {
    margin-top: 60px;
  }
`;

const Card = Styled.div`
    padding-top: 50px;
    padding-bottom: 80px;
    background-color: #fff;
      @media screen and (max-width: 767px) {
        padding-bottom: 0px;
      }
      @media screen and (max-width: 450px) {
        padding-top: 10px;
      }
`;

const FilterContainer = Styled.div`
    width: 100%;  
    margin: auto;
    display: flex;
    margin-top:30px ; 
    & .content-body{
      background:#F7F6F4;
      .MuiInputBase-root{
         background:#F7F6F4;
      }
    }
`;

const CardContainer = Styled.div`
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #CBCBCB;
    padding-bottom: 50px;
    @media screen and (max-width: 991px) {
        justify-content: space-between;
    }   
    @media screen and (max-width: 767px) {
        flex-direction: column;
        &.container{
            padding-bottom: 0;
        }
    }
`;

const Thumbnail = Styled.img`
    width: 263px;
    height: 263px;
    border-radius: 50%;
    margin-right: 40px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
   
    background:white;
    object-fit:contain;
    @media screen and (max-width: 991px) {
      margin-right: 0;
    }
    @media screen and (max-width: 899px) {
      height: auto;
      margin: 0 auto;
      border-radius: 0;
    }
`;

const ContactDetail = Styled.div`
    height: 100%;
    @media screen and (max-width: 991px) {
        width: 30%;
        margin-right: 0;
    }
    @media screen and (max-width: 767px) {
        width: 100%;
        margin: 0 auto 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

const ContentDetail = Styled.div`
    height: 100%;
    @media screen and (max-width: 991px) {
        width: 60%;
        margin-right: 0;
    }
    @media screen and (max-width: 767px) {
        width: 100%;
        margin: 0 auto 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

const LabelNameAgency = Styled.h1`
    font-size: 2.188rem;
    font-weight: 700;
    text-align: left;
    margin: 15px 0;
    text-transform: uppercase;
    color:var(--color-brand-blue-main);
    span{
        font-weight: 300;
    }
    @media screen and (max-width: 767px) {
        text-align: center;
        margin-bottom: 30px;
        font-size: 1.788rem;
    }
`;

const ContentInfo = Styled.ul`
    list-style: none;
    @media screen and (max-width: 767px) {
        margin-bottom: 20px;
    }
`;

const ContentInfoItem = Styled.li`
    margin-bottom: 15px;
`;

const Info = Styled.span` 
    display: block;
    font-size: 1.063rem;
    font-weight: 500;
    color:var(--color-brand-blue-main);
    max-width:450px;
    // white-space:;
    &.--description{
        color: var(--color-brand-grey-secondary);
    }
`;

export default AgencyProfileContain;

const adapterAgent = (data: any): any => {
  let brokers = "";

  if (data != null && data.brokers != null) {
    brokers = data.brokers.map((x: any) => x.broker_name).join(", ");
  }

  return {
    id: data?.id ?? null,
    name: data?.name ?? "-",
    agency_name: data?.agency_name ?? "-",
    phone: data?.phone ?? "-",
    address: data?.address ?? "-",
    email: data?.email ?? "-",
    picture: data?.logo ?? AgencyPicPlaceholder,
    brokers,
  };
};
